<template>
  <b-row>
    <b-col
      v-if="card"
      cols="12"
    >
      <b-card>
        <b-card-body>
          <b-row
            align-h="center"
            align-v="center"
            style="flex-direction:row-reverse"
          >
            <b-col
              cols="12"
              sm="5"
              md="3"
              class="mb-3 mb-sm-0 d-flex justify-content-center"
            >
              <feather-icon
                variant="success"
                icon="CheckCircleIcon"
                size="150"
                color="#94d56c"
              />
            </b-col>
            <b-col
              cols="12"
              sm="7"
              md="9"
            >
              <h3 class="font-weight-bold mb-4">
                {{ $t('user_no_active.register_success_confirm_email') }}
              </h3>
              <h3> {{ $t('user_no_active.description1') }}</h3>
              <h3> {{ $t('user_no_active.description2') }}</h3>
              <h3 class="text-danger">
                {{ $t('user_no_active.email_process') }}
              </h3>
              <div class="mt-5 text-center">
                <h4> {{ $t('user_no_active.email_resend') }}</h4>
                <b-button
                  class="text-nowrap"
                  :disabled="sendMaliLoading || !(remainingTime.minutes === 0 && remainingTime.seconds === 0)"
                  variant="primary"
                  @click="resendActivationEmail"
                >
                  <span>{{ $t('user_no_active.resend_email_btn') }}</span>
                  <span
                    v-if="remainingTime.minutes > 0 || remainingTime.seconds > 0"
                    class="mx-1"
                    dir="rtl"
                  >

                    {{ formatTime(remainingTime.seconds) }}
                    :
                    {{ formatTime(remainingTime.minutes) }}
                  </span>
                </b-button>
              </div>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </b-col>
    <b-col v-else>
      <DashboardAlert
        variant="warning"
        bg-variant="light"
      >
        <div>
          <h2>{{ $t('user_no_active.register_success_confirm_email') }}</h2>
          <p>{{ $t('user_no_active.description1') }}</p>
          <hr>
          <p class="mb-2">
            {{ $t('user_no_active.email_process') }} {{ $t('user_no_active.email_resend') }}
          </p>
          <b-button
            :disabled="sendMaliLoading || !(remainingTime.minutes === 0 && remainingTime.seconds === 0)"
            variant="warning"
            pill
            @click="resendActivationEmail()"
          >
            <span>{{ $t('user_no_active.resend_email_btn') }}</span>
            <span
              v-if="remainingTime.minutes > 0 || remainingTime.seconds > 0"
              class="mx-1"
            >

              {{ formatTime(remainingTime.seconds) }}
              :
              {{ formatTime(remainingTime.minutes) }}

            </span>
          </b-button>
        </div>
      </DashboardAlert>
    </b-col>
  </b-row>
</template>

<script>
import resendEmail from '@/views/logics/components/registerSteps/resendEmail'
import DashboardAlert from '../../dashboard/dashboardAlert.vue'

export default {
  components: {
    DashboardAlert,
  },
  mixins: [resendEmail],
}
</script>
